module.exports = __webpack_public_path__ + "static/media/DeleteTicketIcon.fadd3f72.svg";